import { AllSelectOption, BooleanSelectOption } from '@storage/app/models'

export const mapOptionalFieldValueToBoolean = (
  value: AllSelectOption | BooleanSelectOption,
): boolean | undefined => {
  return value === 'All' ? undefined : value === BooleanSelectOption.True
}
